import { createContext } from 'react';

const GlobalContext = createContext({
    socket: null,
    isOpen: {},
    setIsOpen: (open) => { }
});

export default GlobalContext;